<div class="mapa-pendencias">
    <app-painel-lateral
        [tituloPainel]="'Mapa de Pendências'"
        [descricaoPainel]="'Visão geral de pendências e inconsistências de registros cadastrais de médicos.'"
        [iconePainel]="'pi pi-list-check'"
        [filtrosTemplate]="filtros"
        [conteudoTemplate]="conteudo"
        [ocultarFiltros]="!!indicadorSelecionado"
    >
        <ng-template #filtros>
            <app-mapa-uf-card [uf]="ufSelecionada" (ufChange)="onUfSelecionadaChange($event)"></app-mapa-uf-card>
            <label class="mapa-filtro">
                <span class="mapa-filtro-label">UF do estado</span>
                <app-estado-select [uf]="ufSelecionada ?? 'BR'" [ufsPermitidas]="ufsPermitidas" (ufChange)="onUfSelecionadaChange($event)"></app-estado-select>
            </label>
        </ng-template>

        <ng-template #conteudo>
            @if (indicadorSelecionado) {
                <app-detalhamento-pendencias
                    [indicador]="indicadorSelecionado"
                    [linhas]="linhasPendencias"
                    [first]="first"
                    [rows]="rows"
                    [totalRecords]="totalRegistros"
                    [carregando]="carregandoPendencias"
                    [voltarNoCard]="true"
                    [permitirVisualizacaoCard]="true"
                    (voltar)="voltarParaMapa()"
                    (paginaAlterada)="onPageChange($event)"
                ></app-detalhamento-pendencias>
            } @else {
                <div class="mapa-indicadores">
                    <div class="indicadores-grid">
                        @for (indicador of indicadores; track indicador.id) {
                            <div class="card-entrada card-entrada-1 indicador-card" [ngClass]="indicador.classeGrupo">
                                <app-card-content [border]="false" [title]="indicador.titulo" [subtitle]="indicador.descricao" [icon]="indicador.icone || 'pi pi-exclamation-circle'">
                                    <div card-header class="flex items-center gap-2" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarIndicador(indicador)"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarIndicador(indicador)"></p-button>
                                    </div>
                                    <div class="estatistica-total-bloco">
                                        @if (indicador.quantidade !== null) {
                                            <span class="estatistica-total-valor">{{ indicador.quantidade | number }}</span>
                                            <span class="estatistica-total-label">registros</span>
                                        } @else {
                                            @if (ufSelecionada && ufSelecionada !== 'BR') {
                                                <p-skeleton width="92px" height="30px" />
                                            } @else {
                                                <span class="estatistica-total-valor" style="font-size: 1.25rem; font-weight: 600">Sem dados</span>
                                                <span class="estatistica-total-label">aguardando carga</span>
                                            }
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                        }
                    </div>
                </div>
            }
        </ng-template>
    </app-painel-lateral>
</div>

<p-dialog
    appDialogoPadrao="pi pi-users"
    descricao="Pendências do indicador em tela cheia."
    [(visible)]="exibirModalMaximizado"
    [header]="indicadorMaximizado?.titulo ?? ''"
    [style]="{ width: '90vw', maxWidth: '560px' }"
    [breakpoints]="{ '640px': '95vw' }"
    [dismissableMask]="true"
    (onHide)="indicadorMaximizado = null"
    styleClass="modal-estatistica-custom"
>
    @if (indicadorMaximizado) {
        <div class="estatistica-card modal-card-wrapper" [ngClass]="indicadorMaximizado.classeGrupo">
            <div class="estatistica-topo">
                <div class="estatistica-identidade">
                    <span class="estatistica-icone">
                        <i [class]="indicadorMaximizado.icone || 'pi pi-exclamation-circle'"></i>
                    </span>
                    <p-tag [rounded]="true" class="grupo-badge">{{ indicadorMaximizado.grupo }}</p-tag>
                </div>

                <div class="estatistica-acoes" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()">
                    <p-button
                        icon="pi pi-table"
                        styleClass="botao-topo-acao"
                        [text]="true"
                        [rounded]="true"
                        title="Visualizar dados estatísticos"
                        ariaLabel="Visualizar dados estatísticos"
                        (onClick)="$event.stopPropagation(); selecionarIndicador(indicadorMaximizado)"
                    ></p-button>
                </div>
            </div>

            <div class="estatistica-total-bloco">
                @if (indicadorMaximizado.quantidade !== null) {
                    <span class="estatistica-total-valor">{{ indicadorMaximizado.quantidade | number }}</span>
                    <span class="estatistica-total-label">registros</span>
                } @else {
                    <p-skeleton width="92px" height="30px" />
                }
            </div>

            <p class="estatistica-descricao">{{ indicadorMaximizado.descricao }}</p>
        </div>
    }
</p-dialog>
